/**
 * UIkit alert class modifiers.
 */
export type AlertModifierModel = 'primary' | 'success' | 'warning' | 'danger';
